var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlyssia2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 182.4 324.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-7 {\n        stroke-width: 2.8px;\n      }\n\n      .cls-1, .cls-7, .cls-9 {\n        stroke: #000;\n      }\n\n      .cls-10 {\n        fill: #6e2f22;\n      }\n\n      .cls-11 {\n        fill: #e296cf;\n      }\n\n      .cls-2 {\n        stroke: #6e2f22;\n        stroke-width: 4px;\n      }\n\n      .cls-12 {\n        fill: #260809;\n      }\n\n      .cls-3 {\n        stroke: #000d19;\n      }\n\n      .cls-3, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-6 {\n        stroke-width: 3.8px;\n      }\n\n      .cls-13 {\n        opacity: .5;\n      }\n\n      .cls-13, .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        fill: #4d65b4;\n      }\n\n      .cls-16 {\n        fill: #aa3d74;\n        opacity: .4;\n      }\n\n      .cls-17 {\n        fill: #4d1417;\n      }\n\n      .cls-18 {\n        fill: #b7c8d8;\n      }\n\n      .cls-4 {\n        stroke: #f5c13d;\n        stroke-width: 3.1px;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-28 {\n        fill: #e6eef2;\n      }\n\n      .cls-29 {\n        fill: #7bd2e8;\n      }\n\n      .cls-30 {\n        fill: #ffd24a;\n      }\n\n      .cls-31 {\n        fill: #8c432b;\n      }\n\n      .cls-5 {\n        stroke: #fff;\n        stroke-width: 11px;\n      }\n\n      .cls-32 {\n        fill: #eb175a;\n      }\n\n      .cls-33 {\n        fill: #000d19;\n      }\n\n      .cls-34 {\n        fill: #8695b2;\n      }\n\n      .cls-35 {\n        fill: #4d9be6;\n      }\n\n      .cls-36 {\n        fill: #073f4a;\n      }\n\n      .cls-37 {\n        fill: #ffae4a;\n      }\n\n      .cls-6 {\n        stroke: #b7c8d8;\n      }\n\n      .cls-38 {\n        fill: #8f005d;\n      }\n\n      .cls-39 {\n        fill: #360b0e;\n      }\n\n      .cls-8 {\n        stroke: #d99037;\n        stroke-width: 2px;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-41 {\n        fill: #002131;\n      }\n\n      .cls-9 {\n        stroke-width: 3px;\n      }\n\n      .cls-42 {\n        fill: #033040;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -616.3,
    y: 66.1,
    width: 21,
    height: 29.5,
    rx: -287.1,
    ry: -287.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -576.6,
    y: 66.1,
    width: 21,
    height: 29.5,
    rx: -267.3,
    ry: -267.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 768.6,
    y: 70.4,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 808.2,
    y: 70.4,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 72.5,
    y: 69.7,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(10 -8.8) rotate(6.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 111.9,
    y: 74.2,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(10.8 -13.2) rotate(6.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.5,122.9l-1-1c-.6-.6-1.6-.6-2.2,0l-2.5,2.5-20,20c-.5.5-.9,1.1-1.1,1.8l-2.2,6.2,3.5,3.5,2.1-2.1,20.9-20.9,2.8-8c.2-.7,0-1.4-.4-1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "167.8 130.9 164.9 128 161.3 131.6 140.5 152.4 129.3 184.3 132.2 187.2 134.4 185 156.6 162.8 167.8 130.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "132.2 179.8 142.2 151.9 162 132.1 152.1 159.9 132.2 179.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M156.6,162.8l-2.9-2.9-3.6,3.6-20.8,20.8-1.4,3.9c-.4,1.1-.1,2.4.7,3.2h0c1.2,1.2,3.1,1.2,4.3,0h0s19.1-19.1,19.1-19.1c1.2-1.2,2.1-2.6,2.6-4.2l1.9-5.4Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "alyssia"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 47.9,
    cy: 26.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 61.5,
    cy: 20.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 37.5,
    cy: 35,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 29.3,
    cy: 44.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 22,
    cy: 55.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 18.3,
    cy: 68.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 15.8,
    cy: 81.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 14.3,
    cy: 94.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 14.4,
    cy: 106.6,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 134.7,
    cy: 36.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 122.9,
    cy: 27,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 143,
    cy: 46.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 148.8,
    cy: 58.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 153.5,
    cy: 70.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 154.2,
    cy: 83.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 153.7,
    cy: 97.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 152.3,
    cy: 110.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 149.5,
    cy: 121.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M86,10.9h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1H34c-12.2,0-22.1-9.9-22.1-22.1v-19.2C11.9,44.1,45.1,10.9,86,10.9Z",
    transform: "translate(8.2 -9.2) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-586.9,297.1c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M-596.7,284.9h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(-1161.1 588.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -587.7,
    y: 211.3,
    width: 17.6,
    height: 14,
    transform: "translate(-1157.8 436.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-578.9,191.6c6.8,0,12.4-5.5,12.4-12.4v-28.7c0-6.8-5.5-12.4-12.4-12.4-6.8,0-12.4,5.5-12.4,12.4v28.7c0,6.8,5.5,12.4,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-591.3,179.6v30.4c0,1.8,1.5,3.2,3.2,3.2h18.2c1.8,0,3.2-1.5,3.2-3.2v-30.8c0-7-5.9-12.7-13-12.3s-11.8,6-11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -573.7,
    cy: 225.3,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: -601.7,
    y: 272.8,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-612.9,265.7c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-612.9,310.6c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-586.9,252.2c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-606.4,186.9h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M-597.8,194.8h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M-616.7,140.8h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -613.1,
    y: 126.8,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M-616.3,128.4h29.1c2.4,0,4.4,2,4.4,4.4v12.7h-37.8v-12.7c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M-622.7,298.4h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(-1213.1 615.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -627.7,
    y: 286.3,
    width: 29.7,
    height: 22.5,
    transform: "translate(-1225.7 595.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -647.1,
    cy: 27.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -634.4,
    cy: 19.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -656.5,
    cy: 36.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -663.6,
    cy: 47.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -669.7,
    cy: 59,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -671.9,
    cy: 72.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -672.9,
    cy: 85.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -672.9,
    cy: 98.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -671.4,
    cy: 110.5,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -559.8,
    cy: 27.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -572.5,
    cy: 19.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -550.4,
    cy: 36.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -543.3,
    cy: 47.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -537.3,
    cy: 59,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -535.1,
    cy: 72.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -534,
    cy: 85.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -534,
    cy: 98.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -535.5,
    cy: 110.5,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-604.6,7h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1h-104c-12.2,0-22.1-9.9-22.1-22.1v-19.2c0-40.9,33.2-74.1,74.1-74.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -550.7,
    cy: 81,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -641.2,
    cy: 81,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-608.3,2.4h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7h-78c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-549.6,89.6c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5-11.5-5.2-11.5-11.5,1-5.4,2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-641.2,89.6c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5c6.4,0,11.5-5.2,11.5-11.5,0-2.8-1-5.4-2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-608.5,39.3h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M-577.9,109.4c1.8,0,3,1.9,2.1,3.5-2.5,4.5-7.2,7.6-12.8,7.6s-10.3-3.1-12.8-7.6.3-3.5,2.1-3.5h21.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -616.3,
    y: 66.1,
    width: 21,
    height: 29.5,
    rx: -287.1,
    ry: -287.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -608.4,
    y: 74.5,
    width: 11.7,
    height: 19.6,
    rx: -292.5,
    ry: -292.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -609.3,
    y: 71.4,
    width: 6.4,
    height: 11.7,
    rx: -298.3,
    ry: -298.3
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-616.3,76.9v-.2c0-5.8,4.7-10.5,10.5-10.5h0c5.8,0,10.5,4.7,10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -619.8,
    y1: 73.3,
    x2: -616,
    y2: 74.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -618.4,
    y1: 69.3,
    x2: -614.9,
    y2: 71.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-620.6,88.9h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: -620.3,
    cy: 101,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -576.6,
    y: 66.1,
    width: 21,
    height: 29.5,
    rx: -267.3,
    ry: -267.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -569.5,
    y: 74.5,
    width: 11.7,
    height: 19.6,
    rx: -273,
    ry: -273
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -570.3,
    y: 71.4,
    width: 6.4,
    height: 11.7,
    rx: -278.8,
    ry: -278.8
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-555.6,76.9v-.2c0-5.8-4.7-10.5-10.5-10.5h0c-5.8,0-10.5,4.7-10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -552.1,
    y1: 73.3,
    x2: -555.8,
    y2: 74.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -553.5,
    y1: 69.3,
    x2: -557,
    y2: 71.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-560.2,88.9h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(-1116.6 193.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: -554.7,
    cy: 100.1,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-572.8,73.1h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-615.7,73.1h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-590.7,82.6s1.3-2.8,5.2-2.8,5.2,3.1,5.2,3.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M-585.5,84.3v15.3c0,2.2,1.8,4,4,4h2.4c3,0,5-3.2,3.6-5.9l-7.2-14.1c-.7-1.4-2.8-.9-2.8.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-628.4,42h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -625.9,
    cy: 50.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -626.6,
    cy: 45.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -619.3,
    cy: 43.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -609.5,
    cy: 38.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 60,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 70.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 79.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 106.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 115.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 125.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 88.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630,
    cy: 97.6,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-540.1,40h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(-1093.3 169.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -557,
    cy: 48.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -563.6,
    cy: 41.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -573.4,
    cy: 36.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 58.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 68.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 77.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 104.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 114,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 123.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 86.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.9,
    cy: 95.6,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -636.8,
    y: 224.2,
    width: 17.6,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M-628,204.6c-6.8,0-12.4-5.5-12.4-12.4v-28.7c0-6.8,5.5-12.4,12.4-12.4s12.4,5.5,12.4,12.4v28.7c0,6.8-5.5,12.4-12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M-615.6,192.6v30.4c0,1.8-1.5,3.2-3.2,3.2h-18.2c-1.8,0-3.2-1.5-3.2-3.2v-30.8c0-7,5.9-12.7,13-12.3,6.6.3,11.8,6,11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -633.2,
    cy: 238.2,
    r: 14
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: -599.9,
    y1: 214.8,
    x2: -599.9,
    y2: 284.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M798,297.1c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M788.2,284.9h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(1608.7 588.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 851.2,
    y: 147.2,
    width: 17.6,
    height: 14,
    transform: "translate(668.2 -698.3) rotate(67.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M832.8,177.9c4.8-4.8,4.8-12.7,0-17.5l-20.3-20.3c-4.8-4.8-12.7-4.8-17.5,0-4.8,4.8-4.8,12.7,0,17.5l20.3,20.3c4.8,4.8,12.7,4.8,17.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M829.2,180.6l28-11.8c1.7-.7,2.4-2.6,1.7-4.3l-7.1-16.8c-.7-1.7-2.6-2.4-4.3-1.7l-28.4,11.9c-6.5,2.7-9.4,10.3-6.3,16.7,2.9,6,10.1,8.5,16.3,5.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 864.4,
    cy: 146.7,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 783.2,
    y: 272.8,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M772,265.7c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M772,310.6c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M798,252.2c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M778.5,186.9h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M787.1,194.8h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M768.2,140.8h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 771.8,
    y: 126.8,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M768.4,134.8h29.1c2.4,0,4.4,2,4.4,4.4v6.4h-37.8v-6.4c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M762.2,298.4h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(1556.7 615.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 757.2,
    y: 286.3,
    width: 29.7,
    height: 22.5,
    transform: "translate(1544.1 595.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 737.7,
    cy: 31.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 750.5,
    cy: 23.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 728.4,
    cy: 41.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 721.3,
    cy: 51.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 715.2,
    cy: 63.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 713,
    cy: 76.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 712,
    cy: 90.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 712,
    cy: 103.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 713.4,
    cy: 114.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 825.1,
    cy: 31.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 812.3,
    cy: 23.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 834.5,
    cy: 41.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 841.6,
    cy: 51.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 847.6,
    cy: 63.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 849.8,
    cy: 76.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 850.8,
    cy: 90.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 850.8,
    cy: 103.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 849.4,
    cy: 114.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M780.3,11.4h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1h-104c-12.2,0-22.1-9.9-22.1-22.1v-19.2c0-40.9,33.2-74.1,74.1-74.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 834.2,
    cy: 85.4,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 743.7,
    cy: 85.4,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M776.6,6.7h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7h-78c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.3,94c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5-11.5-5.2-11.5-11.5,1-5.4,2.7-7.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M854.7,75.2c0-7.1-5.8-12.9-12.9-12.9h-12.1c-3.3,0-6.3,1.2-8.5,3.3h0s-.2.2-.2.2c-.3.2-.5.5-.7.7l-4.1,4.1,1.9-.8c-.8,1.6-1.2,3.5-1.2,5.4v20.5c0,7.1,5.8,12.9,12.9,12.9h12.1c1.9,0,3.6-.4,5.2-1.1l-.4,1.6,3.9-4c.3-.3.5-.5.8-.8l.2-.2h0c2-2.3,3.2-5.2,3.2-8.4v-20.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 812.3,
    y: 66.9,
    width: 37.8,
    height: 46.3,
    rx: 12.9,
    ry: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 820.1,
    y: 74.4,
    width: 22.1,
    height: 31.4,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M743.7,94c-6.4,0-11.5,5.2-11.5,11.5,0,6.4,5.2,11.5,11.5,11.5,6.4,0,11.5-5.2,11.5-11.5,0-2.8-1-5.4-2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M776.4,43.6h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.7,116.8c-5.7,2.8-12.2,2.1-17-1.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 768.6,
    y: 70.4,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 776.5,
    y: 78.9,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 775.6,
    y: 75.8,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M768.6,81.3v-.2c0-5.8,4.7-10.5,10.5-10.5h0c5.8,0,10.5,4.7,10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 765.1,
    y1: 77.7,
    x2: 768.8,
    y2: 79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 766.5,
    y1: 73.7,
    x2: 770,
    y2: 75.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M764.3,93.3h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 768.9,
    cy: 106,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 808.2,
    y: 70.4,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 815.4,
    y: 78.9,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 814.5,
    y: 75.8,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M829.3,81.3v-.2c0-5.8-4.7-10.5-10.5-10.5h0c-5.8,0-10.5,4.7-10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 832.8,
    y1: 77.7,
    x2: 829.1,
    y2: 79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 831.4,
    y1: 73.7,
    x2: 827.9,
    y2: 75.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M824.7,93.3h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(1653.2 201.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 830.2,
    cy: 104.7,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M812.1,77.5h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M769.2,77.5h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M794.2,87s1.3-2.8,5.2-2.8,5.2,3.1,5.2,3.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M799.6,90.7v14c0,2,1.8,3.7,4.1,3.7h2.5c3.1,0,5.1-2.9,3.7-5.4l-7.3-12.9c-.7-1.3-2.9-.8-2.9.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 785,
    y1: 214.8,
    x2: 785,
    y2: 284.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M96.7,297.1c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M86.9,284.9h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(206 588.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 140.2,
    y: 136.6,
    width: 17.6,
    height: 14,
    transform: "translate(166.6 -62.5) rotate(50.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M126.4,177.8c5.3-4.3,6.1-12.1,1.8-17.4l-18.1-22.3c-4.3-5.3-12.1-6.1-17.4-1.8-5.3,4.3-6.1,12.1-1.8,17.4l18.1,22.3c4.3,5.3,12.1,6.1,17.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M126.7,177.6l23.6-19.2c1.4-1.1,1.6-3.2.5-4.6l-11.5-14.1c-1.1-1.4-3.2-1.6-4.6-.5l-23.9,19.4c-5.5,4.4-6.2,12.5-1.4,17.8,4.4,5,12.1,5.3,17.3,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 151.1,
    cy: 135.2,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 81.9,
    y: 272.8,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M70.7,265.7c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M70.7,310.6c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M96.7,252.2c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M77.1,186.9h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M86.1,197.7h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M66.8,140.8h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 70.5,
    y: 126.8,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M70,131h26.1c2.4,0,4.4,2,4.4,4.4v10.2h-34.9v-10.2c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M60.9,298.4h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(154 615.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 55.9,
    y: 286.3,
    width: 29.7,
    height: 22.5,
    transform: "translate(141.4 595.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 137.7,
    cy: 90.8,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 47.8,
    cy: 80.7,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M84.9,6.7h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7H52.5c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z",
    transform: "translate(5.7 -10) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.8,99.5c6.3.7,10.9,6.4,10.1,12.7s-6.4,10.9-12.7,10.1-10.9-6.4-10.1-12.7,1.6-5.2,3.5-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.9,89.2c-6.3-.7-12,3.8-12.7,10.1s3.8,12,10.1,12.7,12-3.8,12.7-10.1c.3-2.8-.4-5.5-1.8-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M79.8,44h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z",
    transform: "translate(10.6 -9.8) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M107.5,116c1.8.2,2.8,2.2,1.7,3.7-2.9,4.2-8.1,6.7-13.5,6.1s-9.9-4.2-11.8-9,.7-3.4,2.5-3.2l21.1,2.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 72.5,
    y: 69.7,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(10 -8.8) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 79.9,
    y: 80.8,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8,
    transform: "translate(10.7 -9.1) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 79.9,
    y: 77.3,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2,
    transform: "translate(9.9 -8.8) rotate(6.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73,79.4v-.2c.7-5.8,5.9-9.9,11.7-9.3h0c5.8.7,9.9,5.9,9.3,11.6v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.9,
    y1: 75.4,
    x2: 73.5,
    y2: 77.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.8,
    y1: 71.6,
    x2: 75.1,
    y2: 73.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M66.4,91.2h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z",
    transform: "translate(11.5 -7.3) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 111.9,
    y: 74.2,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(10.8 -13.2) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 118.3,
    y: 85.4,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8,
    transform: "translate(11.5 -13.3) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 118.2,
    y: 82,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2,
    transform: "translate(10.6 -13.1) rotate(6.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.3,86.2v-.2c.7-5.8-3.5-11-9.3-11.6h0c-5.8-.7-11,3.5-11.6,9.3v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.2,
    y1: 83,
    x2: 133.3,
    y2: 83.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.2,
    y1: 78.9,
    x2: 132.6,
    y2: 80.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M126.5,97.7h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(244.2 224.6) rotate(-173.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 130.6,
    cy: 109.9,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 71,
    cy: 103.8,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M115.1,81.4h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z",
    transform: "translate(11.3 -13.3) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M72.5,76.6h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z",
    transform: "translate(10.5 -8.6) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.8,87.9s1.6-2.7,5.5-2.2,4.9,3.6,4.9,3.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.8,90.1l-1.6,14.3c-.2,2.1,1.3,3.9,3.4,4.2l2.3.3c2.9.3,5.1-2.4,4-5.1l-5.3-13.9c-.5-1.4-2.6-1.1-2.8.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M70.3,41.2h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z",
    transform: "translate(10 -6.3) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 76.9,
    cy: 50.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 76.8,
    cy: 45.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 84.3,
    cy: 44.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 94.5,
    cy: 41,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 71.7,
    cy: 60.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 70.6,
    cy: 70.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 79.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 66.5,
    cy: 106.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 65.5,
    cy: 115.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 64.4,
    cy: 124.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 68.6,
    cy: 88.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 67.5,
    cy: 97.6,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M147.8,50.3h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(271 205.5) rotate(-173.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.1,
    cy: 57.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 129.3,
    cy: 49.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 120.2,
    cy: 43.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 138.1,
    cy: 67.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 137,
    cy: 77.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.9,
    cy: 86.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 132.8,
    cy: 114.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 131.8,
    cy: 123.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 130.8,
    cy: 132.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 134.9,
    cy: 96,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 133.9,
    cy: 105.1,
    r: 6.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 83.7,
    y1: 214.8,
    x2: 83.7,
    y2: 284.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.5,122.9l-1-1c-.6-.6-1.6-.6-2.2,0l-2.5,2.5-20,20c-.5.5-.9,1.1-1.1,1.8l-2.2,6.2,3.5,3.5,2.1-2.1,20.9-20.9,2.8-8c.2-.7,0-1.4-.4-1.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M140.3,153l2.4-7.4,24.1-24.1c.1-.1.4,0,.3.2l-2.5,7-24.4,24.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "167.8 130.9 164.9 128 161.3 131.6 140.5 152.4 129.3 184.3 132.2 187.2 134.4 185 156.6 162.8 167.8 130.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "129.3 184.3 138.6 154.3 164.9 128 153.7 159.9 129.3 184.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "132.2 179.8 142.2 151.9 162 132.1 152.1 159.9 132.2 179.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "134.4 172.8 136.5 166.5 161.5 135.5 159.3 142 134.4 172.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "130.9 182 133 176.6 158.5 145 156 150.7 130.9 182"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M156.6,162.8l-2.9-2.9-3.6,3.6-20.8,20.8-1.4,3.9c-.4,1.1-.1,2.4.7,3.2h0c1.2,1.2,3.1,1.2,4.3,0h0s19.1-19.1,19.1-19.1c1.2-1.2,2.1-2.6,2.6-4.2l1.9-5.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M127.9,188.1l1.2-3.5,24.7-24.7-1.7,4.8c-.7,2-1.8,3.7-3.3,5.2l-19.2,19.2c-.7.7-2,0-1.6-1Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 154.7,
    cy: 134.9,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-49.3 157.2) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 156.2,
    cy: 134.4,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-48.5 158.2) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 155.2,
    cy: 136.4,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-50.2 158.1) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 153.8,
    cy: 136.7,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-51 157.1) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 145.1,
    cy: 169.7,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-78 161.4) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 146.9,
    cy: 169.2,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-77 162.6) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 145.9,
    cy: 171.4,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-79 162.5) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 144,
    cy: 171.9,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-80 161.3) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 140.7,
    cy: 175.2,
    rx: 2.3,
    ry: 1,
    transform: "translate(-83.5 159.9) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 140,
    cy: 174.5,
    rx: 2.3,
    ry: 1,
    transform: "translate(-83.2 159.2) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.7,
    cy: 130.9,
    rx: 2.5,
    ry: 1.1,
    transform: "translate(-44.8 159.6) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 158.9,
    cy: 130.1,
    rx: 2.5,
    ry: 1.1,
    transform: "translate(-44.4 158.8) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M153.9,168.1l-1.7-1.6,1.7-5,.6-.4,1.6,1.6s-1.1,3.3-1.3,4.1c-.4,1.2-.8,1.3-.8,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M152.2,166.5l1.7-5,.6-.4s-1.1,3.3-1.3,4.1c-.3,1.1-.9,1.3-.9,1.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M167.5,129.6l-1.7-1.6,1.9-5.7,1.4,1.4c.3.3.4.8.3,1.2l-1.4,4.3-.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M165.8,128l1.9-5.7s.4.3.2.9-1.5,4.4-1.5,4.4l-.6.4Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "167.5 129.6 165.8 128 166.4 127.5 168.1 129.2 167.5 129.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 117.3,
    y: 181.1,
    width: 17.6,
    height: 14,
    transform: "translate(-62 314.2) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M95.8,196.6c-4.8,4.8-12.7,4.8-17.5,0l-20.3-20.3c-4.8-4.8-4.8-12.7,0-17.5s12.7-4.8,17.5,0l20.3,20.3c4.8,4.8,4.8,12.7,0,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M87.4,175.7h30.4c1.8,0,3.2,1.5,3.2,3.2v18.2c0,1.8-1.5,3.2-3.2,3.2h-30.8c-7,0-12.7-5.9-12.3-13s6-11.8,12.7-11.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 132.7,
    cy: 182.9,
    r: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M836.9,63.3v-5.2c0-19.6-15.9-35.6-35.6-35.6h-9.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M760.2,78.1c0-7.1-5.8-12.9-12.9-12.9h-12.1c-3.3,0-6.3,1.2-8.5,3.3h0s-.2.2-.2.2c-.3.2-.5.5-.7.7l-4.1,4.1,1.9-.8c-.8,1.6-1.2,3.5-1.2,5.4v20.5c0,7.1,5.8,12.9,12.9,12.9h12.1c1.9,0,3.6-.4,5.2-1.1l-.4,1.6,3.9-4c.3-.3.5-.5.8-.8l.2-.2h0c2-2.3,3.2-5.2,3.2-8.4v-20.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 717.8,
    y: 69.8,
    width: 37.8,
    height: 46.3,
    rx: 12.9,
    ry: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 725.6,
    y: 77.3,
    width: 22.1,
    height: 31.4,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M736.9,90.5v-31.1c0-20.3,16.5-36.8,36.8-36.8h27.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M766.7,44.4h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 769.3,
    cy: 52.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 768.6,
    cy: 47.6,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 775.9,
    cy: 45.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 785.7,
    cy: 40.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 62.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 72.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 81.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 109.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 118.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 127.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 90.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 100,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M844.7,44.4h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(1676.5 178.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 827.9,
    cy: 52.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 821.3,
    cy: 45.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 811.5,
    cy: 40.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 62.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 72.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 81.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 109.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 118.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 127.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 90.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 832,
    cy: 100,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 827.9,
    cy: 47.6,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 735,
    y: 99.2,
    width: 17.6,
    height: 14,
    transform: "translate(1344.9 -344.6) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M771.4,121.8c6.8,0,12.4,5.5,12.4,12.4v28.7c0,6.8-5.5,12.4-12.4,12.4-6.8,0-12.4-5.5-12.4-12.4v-28.7c0-6.8,5.5-12.4,12.4-12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M762.4,142.3l-21.5-21.5c-1.3-1.3-1.3-3.3,0-4.6l12.9-12.9c1.3-1.3,3.3-1.3,4.6,0l21.8,21.8c5,5,4.8,13.1-.4,17.9-4.9,4.5-12.6,4-17.3-.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 742.6,
    cy: 97.6,
    r: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M736,18.2l1.6,21.8,22.9-13.2-18.1-12.3c-2.9-2-6.7.3-6.5,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M741.2,23.5l.4,7.7c0,1.7,2,2.8,3.5,1.9l6.1-3.5c1.5-.9,1.6-3,0-4l-6.5-4.2c-1.6-1-3.7.2-3.6,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M836.5,13.9l-19.9,8.9,20.3,17.1,5.4-21.2c.9-3.4-2.6-6.2-5.7-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M833.4,21l-6.7,3.8c-1.5.9-1.6,3-.1,4l5.9,3.8c1.5.9,3.4,0,3.6-1.7l.7-7.7c.2-1.9-1.8-3.2-3.5-2.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlyssia2);
export default __webpack_public_path__ + "static/media/alyssia_2.be328f33a8ba3ad9f6413ecb961cb3b6.svg";
export { ForwardRef as ReactComponent };